import script from "./imageSearchGoods.vue?vue&type=script&lang=ts&setup=true"
export * from "./imageSearchGoods.vue?vue&type=script&lang=ts&setup=true"

import "./imageSearchGoods.vue?vue&type=style&index=0&id=d5c21ab4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c21ab4"]])

export default __exports__